import { Component, Vue, Prop } from 'vue-property-decorator'
import { InvalidFields } from '../types'

/**
 * TCardWEBのコンポーネント共通で利用できるコンテキスト情報にアクセスするためのMixin
 * ・セッション情報
 * ・システム設定情報
 * ・ユーザ設定情報
 * ・フォーマット情報
 * ・マスタ情報
 */
@Component
export default class TcwFormItemCommon extends Vue {
  @Prop({ default: '' })
  private label!: string
  @Prop({ default: '' })
  private field!: string
  @Prop({ default: '' })
  private placeholder!: string
  @Prop({ type: Boolean, default: false })
  private required!: boolean
  @Prop({ default: 0 })
  private max!: number
  @Prop({ default: 0 })
  private min!: number
  @Prop({ default: '' })
  private width!: string
  @Prop({ default: -1 })
  private labelWidth!: number
  @Prop({ default: 'right' })
  private labelPosition!: 'left' | 'right' | 'top' | null
  @Prop({ type: Boolean, default: false })
  private number!: boolean
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean
  @Prop({ type: Boolean, default: false })
  private help!: boolean
  @Prop({
    default: () => {
      /** */
    }
  })
  protected errorInfo!: InvalidFields

  private get labelWidthStyle(): string {
    return this.labelWidth > 0 ? `${this.labelWidth}em` : ''
  }

  private get rules() {
    const rules = []

    if (this.required) {
      rules.push({
        required: true,
        message: `${this.label}は必ず入力してください。`,
        trigger: 'blur'
      })
    }

    if (this.number) {
      // 数値チェック
      const minMessage = `${this.min >= 0 ? this.min + '以上' : ''}`
      const maxMessage = `${this.max > 0 ? this.max + '以下' : ''}`
      const message = `${minMessage}${maxMessage}${
        minMessage || maxMessage ? 'の' : ''
      }数値で入力してください`
      const rule = {
        type: 'number',
        trigger: 'blur',
        min: this.min,
        max: this.max,
        message
      }
      rules.push(rule)
    } else if (this.min > 0 || this.max > 0) {
      const minMessage = `${this.min > 0 ? this.min + '文字以上' : ''}`
      const maxMessage = `${this.max > 0 ? this.max + '文字以内' : ''}`
      const message = `${minMessage}${maxMessage}${
        minMessage || maxMessage ? 'で' : ''
      }入力してください`
      const rule = { trigger: 'blur', min: this.min, max: this.max, message }
      rules.push(rule)
    }

    return rules
  }

  protected get serverCheckMessage(): string {
    if (this.errorInfo && this.errorInfo[this.field]) {
      const errorInfo = this.errorInfo[this.field]
      return errorInfo.message
    } else {
      return ''
    }
  }

  /**  */
  protected get formItemStyle(): { [key: string]: string } {
    const style: { [key: string]: string } = {}
    if (this.width) {
      style['width'] = this.width
    }
    return style
  }
}
